/**
 * Auto-initializer for BookAndPack.Pages.* classes.
 *
 * Views should use a data attribute to declare which page class to instantiate:
 *   <div data-page-init="AgencyCreate"></div>
 *
 * If the element also has data-page-ko="true", ko.applyBindings(instance) is called.
 *
 * BookAndPack.Pages.* classes register themselves from per-page Vite modules
 * (e.g. Frontend/src/pages/agency-edit.ts).
 */

document.addEventListener('DOMContentLoaded', function () {
    const elements = document.querySelectorAll<HTMLElement>('[data-page-init]');

    elements.forEach(function (el) {
        const pageName = el.getAttribute('data-page-init');
        if (!pageName) return;

        const BookAndPack = (window as any).BookAndPack;
        if (!BookAndPack?.Pages?.[pageName]) {
            console.warn(`[page-initializer] BookAndPack.Pages.${pageName} not found`);
            return;
        }

        const instance = new BookAndPack.Pages[pageName]();

        if (el.getAttribute('data-page-ko') === 'true') {
            const ko = (window as any).ko;
            if (ko) {
                ko.applyBindings(instance);
            } else {
                console.warn('[page-initializer] ko (Knockout) not found for applyBindings');
            }
        }
    });
});
